<script
  setup
  lang="ts"
  generic="
    ListingFilter extends {
      id: string;
      code: keyof Schemas['ProductListingResult']['currentFilters'];
      label: string;
      name: string;
    }
  "
>
import { computed } from "vue";
import type { Schemas } from "#shopware";

const props = defineProps<{
  filter: ListingFilter;
  selectedFilters: Schemas["ProductListingResult"]["currentFilters"];
  isFilterVisible: boolean;
  toggle: Function;
}>();

const emits = defineEmits<{
  (event: "select-value", value: { code: string; value: unknown }): void;
  (event: "update-visibility", flag: boolean): void;
}>();

const currentFilterData = computed(
  () => !!props.selectedFilters[props.filter?.code],
);
const onChangeOption = (): void => {
  emits("select-value", {
    code: props.filter?.code,
    value: !currentFilterData.value,
  });
};
</script>

<template>
  <div 
  ref="dropdownElement"
  :class="{
    'active' : isFilterVisible
  }"
  class="border-b border-gray-200 collapse-item">
    <button
      @click="toggle($event)"
      class="py-4 flex bg-transparent border-0 w-full items-center justify-between text-left cursor-pointer">
      <span class="font-mulish font-semibold text-base 3xl:text-md max-w-[90%] text-grey-700"
      >{{ $t('filters.freeShipping') }}</span
      >
      <span class="accordion-icon">
        <i 
        :class="{
          'icon-minus': isFilterVisible,
          'icon-add': !isFilterVisible
        }"
        class="text-black transform transition-transform duration-200"></i>
      </span>
    </button>
    <transition 
      enter-active-class="transition-all duration-300 ease-in-out overflow-hidden"
      enter-from-class="max-h-0 opacity-0"
      enter-to-class="max-h-[240px] opacity-100"
      leave-active-class="transition-all duration-300 ease-in-out overflow-hidden"
      leave-from-class="max-h-[240px] opacity-100"
      leave-to-class="max-h-0 opacity-0"
    >
      <div 
        v-if="isFilterVisible"
        :id="props.filter.code" 
        class="accordion-content overflow-hidden transition-all max-h-0 duration-300 pr-1">
        <div class="accordian-inner pt-2 pb-6">
          <div class="checkbox-wrap relative flex items-center gap-3 w-full" @click="onChangeOption()">
            <input
              :id="`filter-mobile-${props.filter.id || props.filter.code}`"
              :checked="currentFilterData"
              :name="props.filter.name"
              :value="props.filter.name"
              type="checkbox"
              class="custom-checkbox peer absolute left-0"
            />

            <label
              :for="`filter-mobile-${props.filter.id || props.filter.code}`"
              class="font-mullish font-normal select-none text-sm lg:text-base peer-checked:text-purple peer-checked:font-semibold text-grey-500 cursor-pointer relative inset-0 z-1 leading-none block w-full "
              >
              {{ $t('filters.freeShipping') }}
            </label>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
